import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_API_BASE_URL + '/api/v2/';

export default {
  async login(user) {
    const response = await axios.post(API_URL + "login", user);
    if (response.data.access_token) {
      await localStorage.setItem("userF", JSON.stringify(response.data.access_token));
      await localStorage.setItem("usuarioUsername", response.data.usuarioUsername);
      await localStorage.setItem("usuarioId", response.data.usuarioId);
      await localStorage.setItem("usuarioNombre", response.data.usuarioNombre);
      await localStorage.setItem("usuarioRolId", response.data.usuarioRolId);
      await localStorage.setItem("usuarioRolTxt", response.data.usuarioRolTxt);

      if (response.data.cliente??false) {
        await localStorage.setItem("datosCliente", JSON.stringify(response.data.cliente));
        await localStorage.setItem("datosFarmacia", JSON.stringify(response.data.farmacia));
      }
    }
  },

  async logout() {
    try {
      await axios.post(API_URL + "logout", {}, { headers: authHeader() });
    } finally {
      localStorage.clear();
    }
  },

  async register(user) {
    const response = await axios.post(API_URL + "register", user);
    if (response.data.access_token) {
      localStorage.setItem("userF", JSON.stringify(response.data.access_token));
    }
  },

  async recoverPassword(user) {
    const response = await axios.post(API_URL + "password-forgot", user);
    if (response.data) {
      return response.data;
    }
  },

  
  // USUARIOS
  async usuarios(usuario) {
    const response = await axios.post(API_URL + "usuarios", usuario, { headers: authHeader() });
    if (response.data) {
      return response.data;
    }
  },

  async guardaUsuario(usuario) { 
    const response = await axios.post(API_URL + "guardaUsuario", usuario, { headers: authHeader() });
    if (response.data) {
      return response.data;
    }
  },

  async borraUsuario(userId) { 
    const response = await axios.post(API_URL + "borraUsuario", userId, { headers: authHeader() });
    if (response.data) {
      return response.data;
    }
  },

  async generarClaveUsuario(usuario) { 
    const response = await axios.post(API_URL + "generarClaveUsuario", usuario, { headers: authHeader() });
    if (response.data) {
      return response.data;
    }
  },

  // CONFIGURACION
  async configuracion(configuracion) {
    const response = await axios.post(API_URL + "configuracion", configuracion, { headers: authHeader() });
    if (response.data) {
      return response.data;
    }
  },

  async guardaConfiguracion(configuracion) { 
    const response = await axios.post(API_URL + "guardaConfiguracion", configuracion, { headers: authHeader() });
    if (response.data) {
      return response.data;
    }
  },

  // AUTOCOMPLETA EMPRESAS
  async autocompletaEmpresa(configuracion) {
    const response = await axios.post(API_URL + "autocompletaEmpresa", configuracion, { headers: authHeader() });
    if (response.data) {
      return response.data;
    }
  },

  // AUTOCOMPLETA FARMACIAS: { texto } -> [{ id, label }]
  async autocompletaFarmacia(configuracion) {
    const response = await axios.post(API_URL + "autocompletaFarmacia", configuracion, { headers: authHeader() });
    return response.data;
  },

  async seleccionaFarmacia(configuracion) {
    const response = await axios.post(API_URL + "seleccionaFarmacia", configuracion, { headers: authHeader() });
    if (response.data) {
      return response.data;
    }
  },
};
